// extracted by mini-css-extract-plugin
export default {"root":"OrDivider_root__u8Dbt","line":"OrDivider_line__44Nn-"};